<template>
  <footer class="text-center bg-indigo-900 p-4">
    <p class="text-indigo-100">By Carlos Daniel OB, <a href="https://carlosdosbe.github.io/linkme" target="_blank">@carlosdosbe <i class="fas fa-link"></i></a></p>
  </footer>
</template>

<script>
export default {
  name: 'footer',
}
</script>